import { FC } from 'react';
import { useTranslation } from '@packages/utils';
import {
  SGroupedSelect,
  GroupedDropdownStyles,
  DROPDOWN_CLASS,
} from './GroupedEventTypeSelect.styles';
import { TGroupedEventTypeSelectProps } from './GroupedEventTypeSelect.types';
import useGroupedEventTypeData from './GroupedEventTypeSelect.data';

const GroupedEventTypeSelect: FC<TGroupedEventTypeSelectProps> = ({
  placeholder,
  ...restProps
}) => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.generic-components.select',
  });
  const { groups } = useGroupedEventTypeData();

  const defaultPlaceholder = placeholder || 'Select Event Type';

  return (
    <>
      <GroupedDropdownStyles />
      <SGroupedSelect
        placement="topLeft"
        placeholder={defaultPlaceholder}
        options={groups}
        popupClassName={DROPDOWN_CLASS}
        cancelBtnText={t('CANCEL_BTN')}
        submitBtnText={t('SUBMIT_BTN')}
        emptyOptionsLabel={t('EMPTY_OPTIONS_LABEL')}
        {...restProps}
      />
    </>
  );
};

export default GroupedEventTypeSelect;
